import type { MessageKey } from './en';

export const zh: Record<MessageKey, string> = {
  'categories.marketPeripheral': '市场外围',
  'categories.analysis': '深度分析',
  'categories.insights': '市场洞察',

  'header.eyebrow': '市场研究',
  'header.searchPlaceholder': '搜索研究内容',
  'header.account': '账户',
  'header.logIn': '登录',
  'header.register': '注册',
  'header.subscribe': '订阅',
  'header.toggleMenu': '打开或关闭菜单',
  'nav.about': '关于我们',

  'footer.research': '研究',
  'footer.firm': '公司',
  'footer.methodology': '研究方法',
  'footer.disclosures': '信息披露',
  'footer.orderReport': '订购报告',
  'footer.newsletterKicker': '每周简报',
  'footer.newsletterHeading': '领先一步把握市场脉络。',
  'footer.newsletterBody': '每周一封精品简报：本周最重要的市场格局、观点变化与板块信号。',
  'footer.emailPlaceholder': '请输入邮箱',
  'footer.emailAriaLabel': '邮箱地址',
  'footer.joinLetter': '订阅简报',
  'footer.blurb': '为认真的自主投资者打造的优质股票研究与市场评论。',
  'footer.copyright': '© {year} Ahead Metric 版权所有。',
  'footer.disclaimerLabel': '免责声明：',
  'footer.disclaimerText': '内容仅供教育参考，不构成投资建议。投资前请咨询专业人士。',

  'publication.feedbackKicker': '读者反馈',
  'publication.feedbackHeading': '提交反馈',
  'publication.feedbackBody': '指出薄弱假设、提出更深入的研究需求，或告诉我们您希望跟踪的方向。',
  'publication.feedbackOpen': '打开反馈表单',
  'publication.feedbackComingSoon': '反馈表单即将上线',
  'publication.newsletterHeading': '获取每周市场简报',
  'publication.newsletterDescription': '每周一篇简明笔记：领涨主线、板块轮动与风险。',
  'publication.newsletterKicker': '订阅通讯',
  'publication.newsletterEmailPlaceholder': '邮箱地址',
  'publication.newsletterSubscribe': '订阅',
  'publication.share': '分享',
  'publication.copyLink': '复制链接',
  'publication.copiedLink': '已复制链接',
  'publication.trustKicker': '研究可信度',
  'publication.trustEducationalOnly': '内容仅供教育参考。',
  'publication.trustNotAdvice': '本文为研究与评论，不构成个性化投资建议。',
  'publication.trustLastReviewed': '最近一次发布审校日期：{date}。',
  'publication.trustGuidance': '请将本研究用于评估风险与论点质量，并结合您自身的投资目标与时间范围加以验证。',

  'home.heroKicker': '优质财富研究刊物',
  'home.latestMarketView': '最新市场观点',
  'home.heroTitle': '为认真的自主投资者提供清晰、严谨的市场研究。',
  'home.heroSubcopy': 'Ahead Metric 将每日市场波动转化为更从容的研究流程：发生了什么变化、为何重要、风险现在何处。',
  'home.readLatest': '阅读最新分析',
  'home.archiveCta': '市场外围档案',
  'home.editorialFocus': '编辑重点',
  'home.featuredResearch': '精选研究',
  'home.focusBody': '以市场结构、论点质量与可信解读为核心的优质阅读体验。',
  'home.focusDailyBrief': '每日市场简报',
  'home.focusDeepDive': '个股深度分析',
  'home.focusSectorMacro': '板块与宏观洞察',
  'home.leadNote': '头条笔记',
  'home.emptyLead': '随着研究库的扩充，新的研究将在此显示。',
  'home.emptyFresh': '新内容编入索引后，最新分析将立即在此显示。',
  'home.piecesAvailable': '{count} 篇内容',
  'home.openResearch': '查看研究',
  'home.atAGlance': '概览',
  'home.coverageMap': '覆盖版图',
  'home.totalNotes': '已发布笔记总数',
  'home.cadence': '发布频率',
  'home.ongoing': '持续更新',
  'home.trustBody': '信任源于时效、清晰和可见的研究档案，而非夸大的承诺。',
  'home.library': '研究库',
  'home.viewAll': '查看全部研究',
  'home.emptyArchive': '暂无文章。添加 Markdown 文件以构建出版档案。',
  'home.recentNotes': '近期笔记',
  'home.whatChanged': '刚刚发生了什么变化',
  'home.seeArchive': '查看档案',

  'category.marketPeripheralDesc': '关于市场趋势、板块分析与经济指标的专业洞察。',
  'category.analysisDesc': '管理和优化投资组合的策略与工具。',
  'category.insightsDesc': '关于市场、经济与投资主题的深度视角与评论。',
  'category.fallbackTitle': '文章',
  'category.fallbackDesc': '浏览我们的内容',
  'category.emptyHeading': '暂无文章',
  'category.emptyBody': '该分类下的文章将在此显示。',
  'category.backHome': '← 返回首页',
  'category.oneArticleFound': '找到 1 篇文章',
  'category.articlesFound': '找到 {count} 篇文章',

  'article.notFound': '未找到文章',
  'article.loadFailed': '文章加载失败',
  'article.loading': '文章加载中…',
  'article.notFoundBody': '您要查看的文章不存在。',
  'article.returnHome': '返回首页',
  'article.backHome': '返回首页',
  'article.related': '相关文章',
  'article.readMore': '阅读更多 →',

  'about.kicker': '关于',
  'about.title': '关于 Ahead Metric',
  'about.subtitle': '让股市教育人人可及',
  'about.missionHeading': '我们的使命',
  'about.missionP1': 'Ahead Metric 创立于一个朴素的信念：优质的投资教育应当人人可及，而不应只属于机构投资者和对冲基金经理。',
  'about.missionP2': '我们为三类核心读者提供深入的市场分析、个股研究与组合策略：学习基础知识的新手、寻找战术机会的日内交易者，以及着眼长期财富积累的投资者。',
  'about.differenceHeading': '我们的与众不同',
  'about.differenceBody': '不同于煽动性的财经媒体，我们专注于教育与赋能。内容立足严谨分析，每篇文章都包含真实数据、透明的方法论和可落地的要点。',
  'about.principlesKicker': '编辑准则',
  'about.valueDataTitle': '数据驱动的分析',
  'about.valueDataDesc': '每一项建议都以扎实的研究和量化分析为支撑。',
  'about.valueUnbiasedTitle': '客观公正的洞察',
  'about.valueUnbiasedDesc': '我们重教育而轻煽动，没有任何隐藏立场。',
  'about.valueAccessibleTitle': '人人可及的学习',
  'about.valueAccessibleDesc': '用浅显的方式讲清复杂概念，适合各层次投资者。',
  'about.disclaimerHeading': '重要免责声明',
  'about.disclaimerStrong': 'Ahead Metric 仅提供教育性内容。',
  'about.disclaimerBody': '本网站任何内容均不构成财务、投资、法律或税务建议。所有内容仅供参考，不应作为投资决策依据。股票市场天然存在风险，历史表现不代表未来结果。做出任何投资决策前，请务必咨询合格的财务顾问。',

  'validation.emailInvalid': '请输入有效的邮箱地址',
  'validation.required': '必填',
  'validation.passwordMin': '密码至少需要 8 个字符',
  'validation.passwordsMismatch': '两次输入的密码不一致',

  'auth.emailLabel': '邮箱地址',
  'auth.recoveryKicker': '账户恢复',
  'auth.passwordMinPlaceholder': '至少 8 个字符',

  'login.kicker': '登录',
  'login.title': '欢迎回来',
  'login.subcopy': '登录以访问您的 AheadMetric 账户。',
  'login.invalidCredentials': '邮箱或密码不正确。',
  'login.passwordLabel': '密码',
  'login.passwordPlaceholder': '您的密码',
  'login.forgotPassword': '忘记密码？',
  'login.submitting': '正在登录…',
  'login.submit': '登录',
  'login.noAccount': '还没有账户？',
  'login.createOne': '立即创建',

  'register.kicker': '创建账户',
  'register.title': '加入 AheadMetric',
  'register.subcopy': '为认真的投资者提供优质股票研究与市场评论。',
  'register.emailExists': '该邮箱已注册账户。',
  'register.passwordLabel': '密码',
  'register.submitting': '正在创建账户…',
  'register.submit': '创建账户',
  'register.haveAccount': '已有账户？',
  'register.logIn': '登录',

  'forgot.successKicker': '请查收邮件',
  'forgot.successTitle': '重置链接已发送',
  'forgot.successBody': '如果该邮箱对应的账户存在，您将很快收到密码重置链接。若几分钟内未收到，请检查垃圾邮件文件夹。',
  'forgot.backToSignIn': '返回登录',
  'forgot.title': '重置您的密码',
  'forgot.subcopy': '输入您的邮箱地址，我们将向您发送密码重置链接。',
  'forgot.submitting': '正在发送…',
  'forgot.submit': '发送重置链接',

  'reset.title': '设置新密码',
  'reset.subcopy': '为您的账户设置一个强密码。',
  'reset.newPasswordLabel': '新密码',
  'reset.confirmLabel': '确认新密码',
  'reset.confirmPlaceholder': '再次输入新密码',
  'reset.submitting': '正在更新…',
  'reset.submit': '更新密码',

  'emailConfirm.kicker': '验证您的邮箱',
  'emailConfirm.title': '请查收收件箱',
  'emailConfirm.body': '我们已向您的邮箱发送确认链接。点击链接即可激活账户并开始使用。',
  'emailConfirm.alreadyConfirmed': '已完成确认？',
  'emailConfirm.signIn': '登录',

  'intake.horizon3m': '3 个月',
  'intake.horizon6m': '6 个月',
  'intake.horizon12m': '12 个月',
  'intake.horizon2to3y': '2–3 年',
  'intake.horizon5yPlus': '5 年以上',
  'intake.positionLong': '多头',
  'intake.positionShort': '空头',
  'intake.positionConsidering': '考虑中',
  'intake.positionHolding': '持有中',
  'intake.positionNone': '无持仓',
  'intake.capacityError': '当前订单已满，请在 24–48 小时后再试。',
  'intake.genericError': '出现问题，请重试。',
  'intake.kicker': '订购个股分析',
  'intake.heading': '获取定制报告',
  'intake.body': '提交您关注的股票和问题，我们将在 24 小时内交付个性化的 A/B/C 情景分析。',
  'intake.tickerLabel': '股票代码',
  'intake.companyLabel': '公司名称',
  'intake.questionLabel': '您的问题（{count}/200）',
  'intake.questionPlaceholder': '以当前估值和宏观环境来看，现在是合适的买入时点吗？',
  'intake.horizonLabel': '投资期限',
  'intake.positionLabel': '您的持仓状态',
  'intake.emailLabel': '邮箱地址',
  'intake.emailHelper': '报告将在 24 小时内发送至此邮箱。',
  'intake.oneTime': '一次性付款',
  'intake.redirecting': '正在跳转…',
  'intake.continuePayment': '前往付款 →',
  'validation.emailInvalidShort': '请输入有效邮箱',

  'order.step1Label': '1. 提交',
  'order.step1Desc': '输入股票代码、您的具体问题以及投资期限。',
  'order.step2Label': '2. 付款',
  'order.step2Desc': '通过 Stripe 结账。一口价 19 美元，无需订阅。',
  'order.step3Label': '3. 接收',
  'order.step3Desc': '您的个性化 A/B/C 情景分析将在 24 小时内通过邮件送达。',
  'order.kicker': '个性化个股分析',
  'order.title': '行动之前，先读懂你的股票',
  'order.subcopy': '提交股票代码和您的问题，24 小时内获得由人工分析师撰写的定制 A/B/C 情景分析。',
  'order.meta': '每份报告 19 美元 · 最多同时受理 3 个订单',
  'order.howItWorks': '服务流程',

  'confirmation.awaitingHeadline': '等待付款',
  'confirmation.awaitingBody': '完成付款以确认订单。',
  'confirmation.confirmedHeadline': '订单已确认',
  'confirmation.confirmedBody': '已收到付款。您的分析已进入队列，将在 24 小时内送达。',
  'confirmation.inProgressHeadline': '分析进行中',
  'confirmation.inProgressBody': '分析师正在撰写您的报告，将在数小时内交付。',
  'confirmation.deliveredHeadline': '报告已送达',
  'confirmation.deliveredBody': '您的分析已发送至您的邮箱，请查收。',
  'confirmation.refundedHeadline': '订单已退款',
  'confirmation.refundedBody': '该订单已退款。如有疑问请联系我们。',
  'confirmation.expiredHeadline': '订单已过期',
  'confirmation.expiredBody': '付款时限已过。请提交新订单。',
  'confirmation.noToken': '链接中未找到订单令牌。',
  'confirmation.loadError': '无法加载订单状态。',
  'confirmation.loading': '订单状态加载中…',
  'confirmation.kicker': '订单状态',
  'confirmation.ticker': '股票代码',
  'confirmation.status': '状态',
  'confirmation.ordered': '下单时间',
  'confirmation.paid': '付款时间',
  'confirmation.delivered': '送达时间',
  'confirmation.sentNotice': '报告已发送，请查收您提供的邮箱。',
  'confirmation.pollingNotice': '本页面每 5 秒自动刷新一次。',
  'confirmation.statusPendingPayment': '等待付款',
  'confirmation.statusPaid': '已付款',
  'confirmation.statusInProgress': '进行中',
  'confirmation.statusDelivered': '已送达',
  'confirmation.statusRefunded': '已退款',
  'confirmation.statusAbandoned': '已过期',

  'notFound.heading': '页面未找到',
  'notFound.body': '抱歉，您访问的页面不存在或已被移动。',
  'notFound.goHome': '返回首页',
  'notFound.goBack': '返回上一页',

  'markdown.articleImage': '文章图片',
  'markdown.zoomImage': '放大图片：{alt}',
  'markdown.imagePreview': '图片预览',

  // Ads (AdSlot)
  'ads.label': '广告',
};
